import {Operation} from "./Operation.js";


export class Divide extends Operation {

    static symbol = "/";

    /**
     * Perform division on two values.
     * @param {Row} row - The row object containing the values to divide.
     * @returns {number} The result of dividing leftValue by rightValue, or 0 if rightValue is 0.
     */
    perform(row) {
        const [leftValue, rightValue] = this.getOperands(row);
        if (rightValue === 0) {
            return 0; // Avoid division by zero
        }
        return (leftValue || 0) / (rightValue || 1); // Use 1 to avoid NaN for leftValue only
    }
}